import {
  ConsultantEventLog_GetEvents,
  ConsultantQuality_GetConsultantNew,
  OrderHlrCheck
} from "@bonliva-crm/graphql";
import { useRequestOrder, UseRequestOrderParams } from "../use-request-order";
import { HlrOrderParams } from "@bonliva-crm/shared";

type UseHLRRequestOrderParams = Omit<UseRequestOrderParams, "requestFn">;

export function useHLRRequestOrder({
  data,
  consultantData,
  ...props
}: UseHLRRequestOrderParams) {
  return useRequestOrder({
    ...props,
    data,
    consultantData,
    requestFn: (params: HlrOrderParams) =>
      OrderHlrCheck.func(
        {
          consultantId: consultantData._id,
          qualityTemplate: data.templateName,
          qualityCheckName: data.Name,
          params
        },
        {
          refetchQueries: [
            ConsultantEventLog_GetEvents.OperationName,
            ConsultantQuality_GetConsultantNew.OperationName
          ]
        }
      )
  });
}
